import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=78ac723e&scoped=true&v-if=user&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac723e",
  null
  
)

export default component.exports